import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: '1rem',
  lineHeight: 1.2,
  fontFamily: 'Usuzi',
  fontSize: '1.2em',
  padding: theme.spacing(1.5, 3),
  background: theme.palette.background.greenGradient,
  color: theme.palette.text.primary,
  boxShadow: `0 0 0 0 ${theme.palette.background.brand}`,
  transition: 'box-shadow 0.3s ease-in-out',
  '&:hover, &:focus-visible': {
    boxShadow: `0 0 0 10px ${theme.palette.background.brand}33`,
    color: theme.palette.text.primary,
  },
  '.MuiButton-icon svg': {
    fontSize: '1.5em',
  },
  '&.xxl': {
    fontSize: '1.5em',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '1.5vw',
    '.MuiButton-icon svg': {
      fontSize: '2.5vw',
    },
    '&.xxl': {
      fontSize: '2vw',
      padding: theme.spacing(2, 4),
    },
  },
}));

const CustomButton = ({ children = null, ...props }) => {
  return (
    <StyledButton {...props}>
      {children}
    </StyledButton>
  );
};

CustomButton.propTypes = {
  children: PropTypes.node,
};

export default CustomButton;
